export const copyToClipboard = (text: string) => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  navigator.clipboard.writeText(el.value).then(() => {
    document.body.removeChild(el);
  });
};
